module.exports = __webpack_public_path__ + "img/avatar-test.cd24a18d.svg";